import { Injectable } from '@angular/core';
import { PdfViewerComponent } from 'ng2-pdf-viewer';

@Injectable({
  providedIn: 'root'
})
export class FilePrintService {
  printPdf(pdfViewerRef: PdfViewerComponent): void {
    if (pdfViewerRef && pdfViewerRef.pdfViewer) {
      const pdfDocument = pdfViewerRef.pdfViewer.pdfDocument;
      // Get PDF data and create blob for printing
      pdfDocument?.getData().then((u8: any) => {
        // Create blob from buffer
        const blob = new Blob([u8.buffer], {
          type: 'application/pdf'
        });

        // Create URL and iframe for printing
        const blobUrl = window.URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
          const iframeWindow = iframe.contentWindow;
          if (iframeWindow) {
            iframeWindow.onafterprint = () => {
              console.log('Print dialog closed (not necessarily printed)');
              document.body.removeChild(iframe);
              window.URL.revokeObjectURL(blobUrl);
            };
            iframeWindow.focus();
            iframeWindow.print();
          }
        };
      });
    }
  }
}
